module.exports = __webpack_public_path__ + "img/eye-cross-error.30128b97.svg";